var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2675 12.2498H23.9524C24.6397 12.2498 25.1969 12.807 25.1969 13.4942V20.7642V21.1165C25.1969 22.4051 24.1522 23.4498 22.8635 23.4498H5.59687M2.79688 5.79425V20.9998C2.79688 22.3529 3.89378 23.4498 5.24687 23.4498C6.59997 23.4498 7.69687 22.3529 7.69687 20.9998V13.4942C7.69687 12.807 8.25403 12.2498 8.94132 12.2498H22.708V9.30797C22.708 8.62069 22.1508 8.06353 21.4635 8.06353H13.2648L11.3632 5.11911C11.134 4.76418 10.7404 4.5498 10.3179 4.5498H4.04132C3.35403 4.5498 2.79688 5.10696 2.79688 5.79425Z",
    stroke: "#065EEA",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.dc16d75fafb85770c619a18220dc5ad5.svg";
export { ForwardRef as ReactComponent };